// Vendor libraries
import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = a0 => ({ categories: a0, liClass: "nav-item", level: 1 });
const _c1 = a0 => ({ active: a0 });
const _c2 = (a0, a1) => ({ categories: a0, liClass: "", level: a1 });
function SupportSidebarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SupportSidebarComponent_ng_template_2_li_0_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", category_r1.redirect_url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", category_r1.name, " ");
} }
function SupportSidebarComponent_ng_template_2_li_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function SupportSidebarComponent_ng_template_2_li_0_ng_template_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r2); const category_r1 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.handleCategoryClick(category_r1)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, category_r1.id === ctx_r2.selectedCategory.id || category_r1.id === ctx_r2.selectedCategory.parent_category_id));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", category_r1.name, " ");
} }
function SupportSidebarComponent_ng_template_2_li_0_ul_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SupportSidebarComponent_ng_template_2_li_0_ul_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, SupportSidebarComponent_ng_template_2_li_0_ul_4_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = i0.ɵɵnextContext().$implicit;
    const level_r4 = i0.ɵɵnextContext().level;
    i0.ɵɵnextContext();
    const template_r5 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", template_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c2, category_r1.sub_categories, level_r4 + 1));
} }
function SupportSidebarComponent_ng_template_2_li_0_ul_5_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", content_r6.redirect_url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", content_r6.title, " ");
} }
function SupportSidebarComponent_ng_template_2_li_0_ul_5_li_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵlistener("click", function SupportSidebarComponent_ng_template_2_li_0_ul_5_li_1_ng_template_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r7); const content_r6 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.handleContentClick(content_r6.id)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate1("href", "#", content_r6.slug, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, content_r6.id === ctx_r2.selectedContentId));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", content_r6.title, " ");
} }
function SupportSidebarComponent_ng_template_2_li_0_ul_5_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, SupportSidebarComponent_ng_template_2_li_0_ul_5_li_1_a_1_Template, 2, 2, "a", 11)(2, SupportSidebarComponent_ng_template_2_li_0_ul_5_li_1_ng_template_2_Template, 2, 6, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r6 = ctx.$implicit;
    const noLinkContent_r8 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isRedirect(content_r6))("ngIfElse", noLinkContent_r8);
} }
function SupportSidebarComponent_ng_template_2_li_0_ul_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, SupportSidebarComponent_ng_template_2_li_0_ul_5_li_1_Template, 4, 2, "li", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r1.content);
} }
function SupportSidebarComponent_ng_template_2_li_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, SupportSidebarComponent_ng_template_2_li_0_a_1_Template, 2, 2, "a", 6)(2, SupportSidebarComponent_ng_template_2_li_0_ng_template_2_Template, 2, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, SupportSidebarComponent_ng_template_2_li_0_ul_4_Template, 2, 5, "ul", 7)(5, SupportSidebarComponent_ng_template_2_li_0_ul_5_Template, 2, 1, "ul", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = ctx.$implicit;
    const noLink_r9 = i0.ɵɵreference(3);
    const ctx_r9 = i0.ɵɵnextContext();
    const liClass_r11 = ctx_r9.liClass;
    const level_r4 = ctx_r9.level;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(liClass_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isRedirect(category_r1))("ngIfElse", noLink_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", category_r1.sub_categories.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", level_r4 > 1 && category_r1.content.length > 0);
} }
function SupportSidebarComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SupportSidebarComponent_ng_template_2_li_0_Template, 6, 6, "li", 5);
} if (rf & 2) {
    const categories_r12 = ctx.categories;
    i0.ɵɵproperty("ngForOf", categories_r12);
} }
export class SupportSidebarComponent {
    constructor() {
        this.categories = [];
        this.selectedCategoryChange = new EventEmitter();
        this.selectedContentIdChange = new EventEmitter();
    }
    handleCategoryClick(category) {
        this.selectedCategory = category;
        this.selectedCategoryChange.emit(this.selectedCategory);
        window.location.hash = category.internal_name ? category.internal_name : '';
    }
    handleContentClick(contentId) {
        this.selectedContentId = contentId;
        this.selectedContentIdChange.emit(this.selectedContentId);
    }
    isRedirect(item) {
        return item.redirect_url !== null && item.redirect_url.length > 0;
    }
}
SupportSidebarComponent.ɵfac = function SupportSidebarComponent_Factory(t) { return new (t || SupportSidebarComponent)(); };
SupportSidebarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SupportSidebarComponent, selectors: [["ycn-support-sidebar"]], inputs: { selectedCategory: "selectedCategory", selectedContentId: "selectedContentId", categories: "categories" }, outputs: { selectedCategoryChange: "selectedCategoryChange", selectedContentIdChange: "selectedContentIdChange" }, decls: 4, vars: 4, consts: [["template", ""], ["noLink", ""], ["noLinkContent", ""], [1, "nav", "nav-tabs", "nav-sticky"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "class", 4, "ngFor", "ngForOf"], ["class", "nav-link", "target", "_blank", 3, "href", 4, "ngIf", "ngIfElse"], [4, "ngIf"], ["target", "_blank", 1, "nav-link", 3, "href"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "ngClass"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "href", 4, "ngIf", "ngIfElse"], ["target", "_blank", 3, "href"], [3, "click", "ngClass", "href"]], template: function SupportSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 3);
        i0.ɵɵtemplate(1, SupportSidebarComponent_ng_container_1_Template, 1, 0, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, SupportSidebarComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const template_r5 = i0.ɵɵreference(3);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngTemplateOutlet", template_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, ctx.categories));
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet], encapsulation: 2 });
